import { URL_BASE_API } from '../configs/urlConfigs' 
import { PAGENUMROWS_NOTIFICATIONS } from '../configs/staticConfigs'; 
import service from './api';

export const fcmNotifiTokenSave = (request) => {
    let ENDPOINT = URL_BASE_API+'user/save-fcm-token/'; 
    return service.post(ENDPOINT,request.data);    
}; 

export const fcmNotificationSend = (request) => {
    let ENDPOINT = URL_BASE_API+'user/send-fcm-notification/'; 
    return service.post(ENDPOINT,request.data);    
}; 

export const notificationsFetch = (request) => {
    let pageSize = PAGENUMROWS_NOTIFICATIONS; 
    let refType = ''; 
    let refId = 0;
    let page = 1; 
    if(request.data!==undefined) {
        if(request.data.hasOwnProperty('page'))     page     = Number(request.data.page); 
        if(request.data.hasOwnProperty('pageSize')) pageSize = Number(request.data.pageSize); 
        if(request.data.hasOwnProperty('refType'))  refType  = request.data.refType; 
        if(request.data.hasOwnProperty('refId'))    refId    = Number(request.data.refId); 
    }
    let ENDPOINT = URL_BASE_API+'fetch-notifications/?page='+page+'&page_size='+pageSize; 
    // For logs against a Project: fetch-logs/?page_size=10&event_id=67 
    // For logs against a Shift: fetch-logs/?page_size=10&shift_id=182
    if(refType!=='' && refId > 0) ENDPOINT += '&'+refType+'='+refId;  

    return service.get(ENDPOINT,request.data); 
}; 

export const notificationRead = (request) => {
    let notifi_id = request.data.id;
    const ENDPOINT = URL_BASE_API+'change-notification-status/?user_notif_id='+notifi_id;
    return service.put(ENDPOINT);
};

export const notificationsFetchDropDown = (request) => {
    let pageSize = PAGENUMROWS_NOTIFICATIONS; 
    if(request.data!==undefined) {
        if(request.data.hasOwnProperty('pageSize')) pageSize = Number(request.data.pageSize); 
    }
    let ENDPOINT = URL_BASE_API+'fetch-notifications/?page_size='+pageSize; 
    return service.get(ENDPOINT,request.data);    
}; 

export const notificationsAllMarkAsRead = (request) => {
    let ENDPOINT = URL_BASE_API+'make-all-notifications-read/'; 
    return service.post(ENDPOINT);  
}; 




